import {
  ODataHeader,
  ODataString,
  ODataDate,
  ODataDecimal,
  ODataBoolean,
  ODataDateTime
} from "pbas-vue-components";

const balanceHistoryHeaders = [
  new ODataHeader({
    type: new ODataString("Id"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.term",
    type: new ODataString("Term/FullName"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.start_date",
    type: new ODataDate("Term/StartDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.end_date",
    type: new ODataDate("Term/EndDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.member_sick_payment_balance.total_credited",
    type: new ODataDecimal("TotalCredited", {
      getString: (item, type) => {
        if (item.TerminatedAt !== null && item.TerminatedAt !== undefined) {
          return "0.00";
        }
        const value = item.TotalCredited;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return value.toFixed(2);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.member_sick_payment_balance.total_deducted",
    type: new ODataDecimal("UsedHours", {
      getString: (item, type) => {
        if (item.TerminatedAt !== null && item.TerminatedAt !== undefined) {
          return "0.00";
        }
        const value = item.UsedHours;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return value.toFixed(2);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "views.balancepayments.balance",
    type: new ODataDecimal("Balance", {
      getString: (item, type) => {
        if (item.TerminatedAt!==null && item.TerminatedAt!==undefined) {
          return "0.00";
        }
        const value = item.Balance;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return value.toFixed(2);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  // new ODataHeader({
  //   title: "headers.member_sick_payment_balance.sick_days",
  //   type: new ODataDecimal("SickDays", {
  //     getString: (item, type) => {
  //       const value = item.SickDays;
  //       if (value === null || value === undefined) {
  //         return "";
  //       }
  //       if (typeof value !== "number") {
  //         return value;
  //       }
  //       return value.toFixed(1);
  //     },
  //   }),
  //   sortable: true,
  //   visible: true,
  //   searchable: true,
  // }),
  new ODataHeader({
    title: "headers.member_sick_payment_balance.extra",
    type: new ODataDecimal("MemberParameters[]/Value", {
      getString: (item, type) => {
        const totalImported = item.IsQualified? item.MemberParameters.map(o=>parseFloat(o.Value)).reduce((partialSum, a) => partialSum + a, 0): 0;
        console.log("---------------------------total imported: ", totalImported);
        let value = totalImported - item.TotalCredited;
        if (value < 0) {
          value = 0;
        }
        return value.toFixed(2);
      },
    }),
    sortable: false,
    visible: true,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataDate("TerminatedAt"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    type: new ODataBoolean("IsQualified"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false
  }),
];
export default balanceHistoryHeaders;
